export type IntakeIntent = 'm2m' | 'aeo' | 'agency' | 'unsure';

export type IntakeRouteDetail = {
  intent: IntakeIntent;
  productHint?: string;
  sourceId?: string;
};

export function routeToIntake(detail: IntakeRouteDetail) {
  window.dispatchEvent(new CustomEvent<IntakeRouteDetail>('macellum:intake-route', { detail }));
  document.getElementById('intake')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
